// dependencies
import { useQuery } from "@tanstack/react-query";

import { getOutlooks } from "../../services";

// api services

export const useOutlooks = () => {
	return useQuery({
		queryKey: ["outlooks"],
		queryFn: () => getOutlooks(),
		refetchOnWindowFocus: false,
		meta: {
			errorMessage: "There was an error getting the outlooks.",
		},
	});
};
